import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-digital-id-settings",
	templateUrl: "./digital-id-settings.component.html",
	styleUrls: ["./digital-id-settings.component.css"],
})
export class DigitalIdSettingsComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
